export default __webpack_public_path__ + "static/media/csv-icon.22c49a3d.svg";